import { render } from "./BulkCreateEnvConfigModal.vue?vue&type=template&id=0c22162c&scoped=true"
import script from "./BulkCreateEnvConfigModal.vue?vue&type=script&lang=js"
export * from "./BulkCreateEnvConfigModal.vue?vue&type=script&lang=js"

import "./BulkCreateEnvConfigModal.vue?vue&type=style&index=0&id=0c22162c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c22162c"]])

export default __exports__